export default __webpack_public_path__ + "static/media/services.a1828f4c.gif";